import React from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import AdminDashboard from './AdminDashboard'

const AdminDashboardWrapper: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Admin Dashboard</PageTitle>
      <AdminDashboard />
    </>
  )
}

export default AdminDashboardWrapper
